import React from "react";
import "./../index.css";

const AboutMe = () => {
  return (
    <section
      data-aos="fade-right"
      className="skills-container"
      name="aboutme"
      id="aboutme"
    >
      <h1 className="heading">A bit about me.. &nbsp;&nbsp;</h1>

      <div className="about-me-container">
      <div className="techs">
      Applied mathematics and machine learning Research and Software Engineer with a focus on deep reinforcement learning and quantitative finance domain.

     </div>
      </div>
    </section>
  );
};

export default AboutMe;
